import React, { Component } from 'react'

import axios from 'axios'
import styled from 'styled-components'
import Papa from 'papaparse'
import moment from 'moment'

import MenuSettings from './MenuSettings'
import MenuPanel from '../MenuPanel/MenuPanel'
import CryptoJS from 'crypto-js'

import Settings from 'settings'
import NoDataSegment from '../../components/NoDataSegment/NoDataSegment'

// DEVELOPMENT
import {
    setCountryDatabase,
    setSiteDatabase,
    resetDatabase,
    resetSiteDatabase,
    saveDbToLocalStorage,
    getDbFromLocalStorage,
    getSlugFromString,
    MongoMenus,
    MongoTypeRecipes,
} from '../../utils/mongo_utils'
import { LoaderConsumer } from '../../utils/LoadingContext'
import slugify from 'slugify'
import { WINREST_API_BASE_URL } from '../../utils/Config'

const SAVED_STATE_KEY = 'newrest-menu'
export const SAVED_RECIPES_PICTURES_WINREST = 'winrest-recipes-pictures'
export const SAVED_RECIPES_PICTURES_EXCEL = 'excel-recipes-pictures'
const EXCEL_CONCEPT = ''
const WINREST_CONCEPT = 'stdr'

const DEFAULT_STATE = {
    winrestURL: '',
    title: null,
    subtitle: null,

    date: moment().format('YYYY-MM-DD'),
    dayCount: 1,
    recipes: [],

    entityId: null,
    siteId: '',
    concept: null,
    forceToday: false,

    service: '',
    language: 'en',
    uiLanguage: 'en',
    winrestLanguage: 'commercialName1',
    menu: '',

    zoom: 1,
    orientation: 'landscape',
    size: 'A4',
    showDate: false,

    minDate: null,
    maxDate: null,
    kiosks: [],
    services: [],
    languages: [],
    concepts: [],
    menus: [],
    data: [],

    displayMode: 'kiosk',
    displayModes: [
        { name: 'Screen', value: 'kiosk', visible: true },
        { name: 'Carrousel', value: 'day', visible: true },
        { name: 'Week', value: 'week', visible: false },
        //{ name: 'Print', value: 'print' },
        { name: 'Labels', value: 'printlabel', visible: true },
    ],
    hideMenuPrice: false,
    hideRecipePoints: false,
    hideEnergyKcal: false,
    showEnergyKcalByPortion: false,
    hideComposition: false,
    hideLabels: false,
    hideIntolerences: false,

    settingsDrawerOpen: true,
    errorFileNotFound: false,
    days: [
        'today',
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thurday',
        'friday',
        'saturday',
    ],
    startDay: 'monday',
    excludedDays: [],
}

class AdminPanel extends Component {
    state = { ...DEFAULT_STATE, dataSource: 'none', loading: true }

    componentWillMount() {
        //this.getLocalStorageDatas()

        const { defaultValues } = this.props

        let newState = {
            loading: false,
            concepts: Settings.concepts.sort((a, b) =>
                a.name.localeCompare(b.name)
            ),
        }

        if (defaultValues) {
            newState = {
                ...newState,
                dataSource: defaultValues.dataSource,
                concept: defaultValues.concept || 'stdr',
                date: defaultValues.date || moment().format('YYYY-MM-DD'),
                defaultValues: {
                    baseUrl: defaultValues.winrestURL,
                    siteId: defaultValues.siteId,
                    pointOfSaleId: defaultValues.pointOfSaleId,
                    guestTypeId: defaultValues.guestTypeId,
                    mealTypeId: defaultValues.mealTypeId,
                    menuId: defaultValues.menuId,
                },
            }
        }

        this.setState({ ...newState })

        // const { defaultValues } = this.props
        // if (defaultValues) {
        //     console.log('defaultValues', defaultValues)
        //     this.setState({
        //         dataSource: defaultValues.dataSource,
        //         concept: 'stdr',
        //         date: defaultValues.date || moment().format('YYYY-MM-DD'),
        //         // defaultValues: {
        //         //     baseUrl: defaultValues.winrestURL,
        //         //     siteId: defaultValues.siteSlug,
        //         // },
        //         loading: false,
        //     })

        //     // dataSource: defaultValues.dataSource,
        //     // winrestURL: defaultValues.winrestURL,
        //     // siteId: defaultValues.siteSlug,
        //     // concept: 'stdr',
        //     // date: defaultValues.date,
        //     //         pointOfSaleSlug: getSlugFromString(
        //     //             decodeURIComponent(defaultValues.pointOfSale)
        //     //         ),
        //     //         guestTypeSlug: getSlugFromString(
        //     //             decodeURIComponent(defaultValues.guestTypeSlug)
        //     //         ),
        //     //         mealTypeSlug: getSlugFromString(
        //     //             decodeURIComponent(defaultValues.mealTypeSlug)
        //     //         ),
        //     //         menuSlug: getSlugFromString(
        //     //             decodeURIComponent(defaultValues.menuSlug)
        //     //         ),
        //     //         language: 'commercialName1_en',
        //     //     },
        //     //     async () => {
        //     //         try {
        //     //             await this.winrestApiFetcher('winrestURL')
        //     //             await this.winrestApiFetcher('siteId')
        //     //             await this.winrestApiFetcher('pointOfSale')
        //     //         } catch (err) {
        //     //             console.log('[ERR]', err)
        //     //         }
        //     //         this.setState({ loading: false })
        // } else {
        //     this.setState({ loading: false })
        // }
    }

    componentDidMount() {
        //window.addEventListener('beforeunload', this.saveState)
    }

    componentWillUnmount() {
        //window.removeEventListener('beforeunload', this.saveState)
    }

    saveRecipesPictures = () => {
        const { recipes, concept, dataSource, kiosks } = this.state
        const typedRecipesPics =
            JSON.parse(
                localStorage.getItem(
                    dataSource === 'excel'
                        ? SAVED_RECIPES_PICTURES_EXCEL
                        : SAVED_RECIPES_PICTURES_WINREST
                )
            ) || {}
        const newRecipesTyped = { ...typedRecipesPics }
        if (!newRecipesTyped[concept]) {
            newRecipesTyped[concept] = {}
        }
        if (dataSource === 'winrest') {
            recipes.map(recipe => {
                const thisRecipe = recipe.split('-')
                newRecipesTyped[concept][thisRecipe[0]] = thisRecipe[1]
            })
        } else if (dataSource === 'winrest2') {
            recipes.map(recipe => {
                const thisRecipe = [
                    recipe.slice(0, recipe.lastIndexOf('-')), 
                    recipe.slice(recipe.lastIndexOf('-') + 1, recipe.length)
                ]
                newRecipesTyped[concept][thisRecipe[0]] = thisRecipe[1]
            })
        } else {
            kiosks.map(({ kioskPicture = '', name }) => {
                newRecipesTyped[concept][name] = kioskPicture
            })
        }
        localStorage.setItem(
            dataSource === 'excel'
                ? SAVED_RECIPES_PICTURES_EXCEL
                : SAVED_RECIPES_PICTURES_WINREST,
            JSON.stringify(newRecipesTyped)
        )
    }

    // saveState = e => {
    //     const {
    //         entityId,
    //         siteId,
    //         concept,
    //         file,
    //         winrestURL,
    //         date,
    //         pointOfSaleSlug,
    //         language,
    //         guestTypeSlug,
    //         mealTypeSlug,
    //         dataSource,
    //     } = this.state
    //     localStorage.setItem(
    //         SAVED_STATE_KEY,
    //         JSON.stringify({
    //             dataSource,
    //             entityId,
    //             siteId,
    //             concept,
    //             file,
    //             winrestURL,
    //             date,
    //             pointOfSaleSlug,
    //             language,
    //             guestTypeSlug,
    //             mealTypeSlug,
    //         })
    //     )
    //     saveDbToLocalStorage()
    //     return false
    // }

    // getLocalStorageDatas = () => {
    //     let savedState = null
    //     getDbFromLocalStorage()
    //     const localStorageContent = localStorage.getItem(SAVED_STATE_KEY)
    //     if (localStorageContent) {
    //         savedState = JSON.parse(localStorageContent) || {}
    //         this.props.setUnloading()
    //         this.setState(
    //             {
    //                 file: savedState
    //                     ? savedState.file
    //                     : `menu-${Settings.concepts[0].code}.${Settings.csvFileVersion}.csv`,
    //                 ...savedState,
    //                 concepts: Settings.concepts.sort((a, b) =>
    //                     a.name.localeCompare(b.name)
    //                 ),
    //                 settingsDrawerOpen: true,
    //             },
    //             () => {
    //                 //localStorage.removeItem(SAVED_STATE_KEY)
    //                 if (this.state.dataSource === 'excel') {
    //                     this.parseFileAndUpdateState()
    //                 }
    //             }
    //         )
    //     }
    // }

    handleChange = (event, source = null, args = null) => {
        if (source === 'winrest2') {
            this.handleChangeWinrest2(args)
            return
        }

        if (!event) {
            return
        }

        const { concept } = this.state
        const { target } = event
        let { name, value, checked, type } = target
        if (type === 'checkbox') {
            value = checked
        }

        const computedState = {}

        if (name.startsWith('kiosk')) {
            const newKiosks = [...this.state.kiosks]
            const kioskArray = name.replace('kiosk_', '').split('-')
            const kioskIndex = parseInt(kioskArray[0])
            const kioskPic = kioskArray[1]
            newKiosks[kioskIndex].enabled = value
            newKiosks[kioskIndex].kioskPicture = kioskPic
            name = 'kiosks'
            value = [...newKiosks]
        } else if (name === 'concept') {
            computedState.recipes = []
            const newKiosks = [...this.state.kiosks]
            computedState.kiosks = newKiosks.map(item => ({
                ...item,
                enabled: false,
                kioskPicture: false,
            }))
            const newFile = `menu-${value}.${Settings.csvFileVersion}.csv`
            this.setState({
                file: newFile,
                dayCount: '1',
                displayMode: 'kiosk',
            })
        } else if (name === 'forceToday') {
            this.setState({
                date: value
                    ? moment().format('YYYY-MM-DD')
                    : this.state.minDate || moment().format('YYYY-MM-DD'),
            })
        } else if (name.startsWith('recipe_')) {
            const { recipes = [] } = this.state
            const newRecipes = [...recipes]
            const recipeId = name.replace('recipe_', '')
            const recipeIndex = newRecipes.indexOf(recipeId)
            const isThere = recipeIndex > -1

            // have to do this cause it's the same event
            // for select / deselect a kiosk and change it's picture
            const pictureUpdated = event.target.src !== ''
            if (isThere && !pictureUpdated) {
                newRecipes.splice(recipeIndex, 1)
            } else {
                let isChanged = false
                let newIndex = -1
                newRecipes.map((recipe, i) => {
                    if (recipe.split('-')[0] === recipeId.split('-')[0]) {
                        isChanged = true
                        newIndex = i
                    }
                })

                if (isChanged) {
                    newRecipes[newIndex] = recipeId
                } else {
                    newRecipes.push(recipeId)
                }
            }
            value = [...newRecipes]
            name = 'recipes'
        } else if (name === 'winrestURL') {
            computedState.siteId = ''
            computedState.pointOfSaleSlug = ''
            computedState.guestTypeSlug = ''
            computedState.menuSlug = ''
            computedState.mealTypeSlug = ''
            computedState.recipes = []
            computedState.language = 'commercialName1_en'
        } else if (name === 'siteId') {
            resetSiteDatabase()
            computedState.pointOfSaleSlug = ''
            computedState.guestTypeSlug = ''
            computedState.menuSlug = ''
            computedState.mealTypeSlug = ''
            computedState.recipes = []
        } else if (name === 'date') {
            computedState.pointOfSaleSlug = ''
            computedState.guestTypeSlug = ''
            computedState.menuSlug = ''
            computedState.mealTypeSlug = ''
            computedState.recipes = []
        } else if (name === 'pointOfSaleSlug') {
            computedState.guestTypeSlug = ''
            computedState.menuSlug = ''
            computedState.mealTypeSlug = ''
            computedState.recipes = []
        } else if (name === 'guestTypeSlug') {
            computedState.menuSlug = ''
            computedState.mealTypeSlug = ''
            computedState.recipes = []
        } else if (name === 'mealTypeSlug') {
            computedState.menuSlug = ''
            computedState.recipes = []
        } else if (name === 'menuSlug') {
            computedState.recipes = []
            computedState.currency = (
                MongoMenus.findOne({
                    slug: value,
                }) || {}
            ).currency
        }

        this.setState(
            {
                ...computedState,
                [name]: typeof value === 'undefined' ? '' : value,
                isChecked: null,
            },
            () => {
                if (name === 'dataSource') {
                    this.props.setLoading()
                    this.setState({
                        ...DEFAULT_STATE,
                        concept:
                            (value === 'winrest' || value === 'winrest2')
                                ? WINREST_CONCEPT
                                : EXCEL_CONCEPT,
                        file: ``,
                        concepts: Settings.concepts.sort((a, b) =>
                            a.name.localeCompare(b.name)
                        ),
                    })
                    if (value === 'excel') {
                        resetDatabase()
                        //his.getLocalStorageDatas()
                    }
                }
                if (
                    (name === 'entityId' ||
                        name === 'siteId' ||
                        name === 'concept' ||
                        name === 'file' ||
                        name === 'startDay' ||
                        name === 'dataSource') &&
                    this.state.dataSource === 'excel'
                ) {
                    this.props.setLoading()
                    this.parseFileAndUpdateState()
                } else if (
                    name === 'menu' ||
                    name === 'dayCount' ||
                    name === 'concept'
                ) {
                    this.updateDisplayModes()
                } else if (
                    ((name === 'siteId' ||
                        name === 'date' ||
                        name === 'forceToday') &&
                        this.state.dataSource === 'winrest') ||
                    (name === 'winrestURL' && value.indexOf('.newrest.eu') > -1)
                ) {
                    if (name === 'winrestURL') {
                        resetDatabase()
                    }
                    this.winrestApiFetcher(name)
                } else if (name === 'recipes' || name === 'kiosks') {
                    this.saveRecipesPictures()
                } else if (name === 'displayMode') {
                    this.setState({ print: false })
                } else if (name === 'uiLanguage') {
                    const language = this.state.winrestLanguage + '_' + value
                    this.setState({ language })
                } else if (name === 'winrestLanguage') {
                    const language = value + '_' + this.state.uiLanguage
                    this.setState({ language })
                }
            }
        )
    }

    handleChangeWinrest2 = args => {
        this.props.setLoading()
        this.setState(
            {
                winrestData: { ...this.state.winrestData, ...args },
                defaultValues: null,
            },
            () => this.props.setUnloading()
        )
    }

    setExcludedDays = event => {
        let value = Array.from(
            event.target.selectedOptions,
            option => option.value
        )
        value = value.map(_ => parseInt(_))
        this.setState({ excludedDays: value })
    }

    updateDisplayModes = () => {
        const newDisplayModes = [...this.state.displayModes]
        if (!!this.state.menu) {
            newDisplayModes.map(_ =>
                _.value !== 'kiosk' ? (_.visible = false) : (_.visible = true)
            )
        } else {
            if (this.state.dayCount > 1) {
                newDisplayModes.map(_ =>
                    _.value === 'kiosk'
                        ? (_.visible = false)
                        : (_.visible = true)
                )
            } else {
                newDisplayModes.map(_ =>
                    _.value === 'week'
                        ? (_.visible = false)
                        : (_.visible = true)
                )
            }
        }

        const firstVisibleDisplayMode = newDisplayModes.filter(
            _ => _.visible
        )[0].value
        const shouldUpdate =
            firstVisibleDisplayMode !== this.state.displayMode &&
            this.state.displayMode !== 'day'
        const isWeekMode =
            this.state.dayCount > 1 && this.state.displayMode === 'week'

        this.setState({
            displayMode:
                shouldUpdate && !isWeekMode
                    ? firstVisibleDisplayMode
                    : this.state.displayMode,
            displayModes: newDisplayModes,
            print: this.state.displayMode === 'week',
        })
    }

    parseFileAndUpdateState = () => {
        const rootPath = Settings.data_root_path[process.env.NODE_ENV]
        const filePath = `${rootPath}/${this.state.entityId}/${this.state.siteId}/${this.state.file}`

        axios.get(filePath).then(response => {
            if (response.status !== 404) {
                this.props.setUnloading()
                this.setState({ errorFileNotFound: false })
                Papa.parse(filePath, {
                    delimiter: ";",
                    header: true,
                    delimiter: ";",
                    download: true,
                    skipEmptyLines: true,
                    complete: this.onParseComplete,
                    error: this.onParseError,
                })
            } else {
                this.props.setUnloading()
                console.log(`Impossible de trouver le fichier ${filePath}`)
                this.setState({ errorFileNotFound: true })
                return
            }
        })
    }

    onParseComplete = result => {
        console.log(result)
        this.setState({ settingsDrawerOpen: true })
        if (result.errors.length > 0) {
            return
        }

        const data = result.data.filter(_ => !!_.date)
        const storedTypedKiosks =
            JSON.parse(localStorage.getItem(SAVED_RECIPES_PICTURES_EXCEL)) || {}

        const kiosks = [...new Set(data.map(_ => _.kiosk_code))].map(_ => {
            return {
                name: _,
                enabled: true,
                kioskPicture: (storedTypedKiosks[this.state.concept] || {})[_],
            }
        })
        const services = [...new Set(data.map(_ => _.service))]
        const languages = [...new Set(data.map(_ => _.language))]
        const menus = [...new Set(data.map(_ => _.menu_code))]
        const dates = [...new Set(data.map(_ => moment(_.date)))]
        const minDate = moment.min(dates)
        const maxDate = moment.max(dates)

        this.setState(
            {
                kiosks,
                date: minDate.format('YYYY-MM-DD'),
                minDate: minDate.format('YYYY-MM-DD'),
                maxDate: maxDate.format('YYYY-MM-DD'),
                services,
                languages,
                menus,
                data,

                service: services[0],
                language: languages[0],
                menu: '',
            },
            () => {
                //this.saveState()
                this.updateDisplayModes()
            }
        )
    }

    openPrintDialog = () => window.print()

    handleOpenDrawerClick = () => {
        if (!this.state.settingsDrawerOpen) {
            this.setState({ settingsDrawerOpen: true })
        }
    }

    handleCloseDrawerClick = () => {
        this.setState(prevState => {
            return { settingsDrawerOpen: !prevState.settingsDrawerOpen }
        })
    }

    winrestApiFetcher = async currentField => {
        const { date, winrestURL, siteId } = this.state
        let path = ''
        let callback

        if (winrestURL && currentField === 'winrestURL') {
            const countryCode = winrestURL.split('.')[0].replace('wr', '')
            path = `${WINREST_API_BASE_URL}/${countryCode}/Information`
            callback = async ({ data = [] }) =>
                await setCountryDatabase({ data })
        } else if (
            winrestURL &&
            siteId &&
            date &&
            ['date', 'siteId', 'forceToday'].indexOf(currentField) > -1
        ) {
            const countryCode = winrestURL.split('.')[0].replace('wr', '')
            path = `${WINREST_API_BASE_URL}/${countryCode}/sites/${siteId}/pointsOfSale/${date}`
            callback = async ({ data = [] }) =>
                await setSiteDatabase({ data, date })
        }

        if (path) {
            this.props.setLoading()
            const url = `https://${winrestURL}/${path}`
            const result = await axios.get(url, {
                headers: { bearer: computeWinrestHash(path) },
            })
            const { data = {} } = result
            if (data) {
                await callback({ data })
            }
            this.props.setUnloading()
        }
    }

    render = () =>
        this.state.loading ? (
            <div></div>
        ) : (
            <div>
                <div
                    style={{
                        position: 'fixed',
                        top: '0',
                        left: '0',
                        bottom: '0',
                        zIndex: '1000',
                        visibility: this.state.settingsDrawerOpen
                            ? 'visible'
                            : 'hidden',
                        height: this.state.settingsDrawerOpen ? 'unset' : 0,
                    }}
                >
                    <MenuSettings
                        openDrawer={this.handleOpenDrawerClick}
                        closeDrawer={this.handleCloseDrawerClick}
                        handleChange={this.handleChange}
                        setExcludedDays={this.setExcludedDays}
                        openPrintDialog={this.openPrintDialog}
                        winrestApiFetcher={this.winrestApiFetcher}
                        {...this.state}
                    />
                    <OpenButton
                        style={{
                            visibility: 'visible',
                        }}
                        opened={this.state.settingsDrawerOpen}
                        onClick={() =>
                            this.setState(({ settingsDrawerOpen }) => ({
                                settingsDrawerOpen: !settingsDrawerOpen,
                            }))
                        }
                    >
                        {this.state.settingsDrawerOpen ? 'X' : '|||'}
                    </OpenButton>
                </div>

                {this.state.errorFileNotFound && <h1>File not found</h1>}

                {!this.state.errorFileNotFound &&
                    this.state.dataSource === 'choose' && (
                        <NoDataSegment message="Please choose a data source" />
                    )}

                {!this.state.errorFileNotFound &&
                    this.state.dataSource !== 'choose' && (
                        <div>
                            <MenuPanel
                                {...this.state}
                                isAdministrationPanel
                                kiosks={this.state.kiosks.reduce(
                                    (result, item) => {
                                        if (item.enabled) {
                                            result.push(
                                                `${item.name}-${
                                                    item.kioskPicture
                                                        ? item.kioskPicture
                                                        : item.name
                                                }`
                                            )
                                        }
                                        return result
                                    },
                                    []
                                )}
                            />
                        </div>
                    )}
            </div>
        )
}

export default LoaderConsumer(AdminPanel)

const OpenButton = styled.button`
    position: absolute;
    z-index: 1;
    right: ${({ opened }) => (opened ? '33px' : '85%')};
    top: 12px;
    border-radius: 50%;
    color: #edeff0;
    border: 1px solid #edeff0;
    height: 35px;
    width: 35px;
    font-size: ${({ opened }) => (opened ? 21 : 17)}px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    outline: none;
    transition: all 0.35s ease-in-out;

    ${({ opened }) => (opened ? '' : 'transform: rotate(90deg);')}
    background-color: rgba(34, 49, 58, 0.93);
    @media print {
        display: none;
    }
`
